var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}import React, { Component } from 'react';
import { Icon } from "../UI";
import { t } from "../I18N";
import ModalTips from "../App/ModalTips";
import { SearchTipsContent } from "../App/SearchTipsContent";

export class SearchInput extends Component {
  render() {
    return (/*#__PURE__*/
      _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
      React.createElement("input", _extends({
        type: "text",
        className: "form-control",
        placeholder: t('System', 'Search', null, false) },
      this.props)
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "search" }), /*#__PURE__*/
      _jsx(ModalTips, {
        label: t('System', 'Search Tips', null, false),
        title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

      _jsx(SearchTipsContent, {})
      )
      ));

  }
}

export default SearchInput;